export default "__VITE_ASSET__Dxut7Ss6__"